"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var Code = function (props) { return (React.createElement(Code.Element, __assign({}, automation_attribute_1.default('code'), props), props.children)); };
Code.Element = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: rgba(0, 0, 0, 0.86);\n  font-family: ", ";\n  font-size: 90%;\n  padding: 0 6px;\n  display: inline-block;\n  background-color: ", ";\n  border-radius: 3px;\n  line-height: 18px;\n  word-break: break-word;\n"], ["\n  color: rgba(0, 0, 0, 0.86);\n  font-family: ", ";\n  font-size: 90%;\n  padding: 0 6px;\n  display: inline-block;\n  background-color: ", ";\n  border-radius: 3px;\n  line-height: 18px;\n  word-break: break-word;\n"])), tokens_1.fonts.family.code, tokens_1.colors.base.blueLightest);
Code.defaultProps = {};
exports.default = Code;
var templateObject_1;
//# sourceMappingURL=code.js.map